import { Equipamento } from '@core/models/models';

export interface GrupoPropriedades<T> {
  titulo: string;
  icone: string;
  itens: T[];
}

export function agruparPorTipoDado<T extends { tipoDado: number }>(
  propriedades: T[]
): GrupoPropriedades<T>[] {
  const texto  = propriedades.filter(p => p.tipoDado === 1);
  const numero = propriedades.filter(p => p.tipoDado === 2);
  const data   = propriedades.filter(p => p.tipoDado === 4);

  const grupos: GrupoPropriedades<T>[] = [];
  if (texto.length)  grupos.push({ titulo: 'Dados Gerais',          icone: 'ri-text',               itens: texto  });
  if (numero.length) grupos.push({ titulo: 'Valores e Quantidades', icone: 'ri-hashtag',             itens: numero });
  if (data.length)   grupos.push({ titulo: 'Datas e Validades',     icone: 'ri-calendar-check-line', itens: data   });
  return grupos;
}

export function getPropriedadeValor(
  equipamento: Equipamento | null | undefined,
  nome: string
): string | null {
  if (!equipamento?.propriedades?.length) return null;
  const prop = equipamento.propriedades.find(
    p => p.nome?.toUpperCase() === nome.toUpperCase()
  );
  if (!prop) return null;
  if (prop.valorDescricao) return prop.valorDescricao;
  return prop.valor || null;
}

export function formatPropriedadeLabel(nome: string): string {
  if (!nome) return '';
  return nome
    .toLowerCase()
    .split('_')
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

export function matchesTipoEspecifico(
  equipamento: Equipamento | null | undefined,
  filtroTipo: string | null | undefined,
): boolean {
  if (!filtroTipo || !equipamento) return true;

  const normalize = (s: string) =>
    s
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toUpperCase()
      .replace(/[\s\-_]+/g, '_');

  const target = normalize(filtroTipo);

  const candidatos: (string | null | undefined)[] = [
    (equipamento as any).tipoEquipamentoEnum,
    getPropriedadeValor(equipamento, 'TIPO'),
    getPropriedadeValor(equipamento, 'CATEGORIA_EQUIPAMENTO_ARMA'),
    getPropriedadeValor(equipamento, 'CATEGORIA'),
    getPropriedadeValor(equipamento, 'NOME'),
    getPropriedadeValor(equipamento, 'NOME_ITEM'),
    equipamento.tipoEquipamento?.designacao,
    equipamento.modelo,
    equipamento.marca,
    getPropriedadeValor(equipamento, 'MODELO'),
    getPropriedadeValor(equipamento, 'MARCA'),
  ];

  return candidatos.some((c) => {
    if (!c) return false;
    const normalizedC = normalize(c);
    return (
      normalizedC === target ||
      normalizedC.includes(target) ||
      target.includes(normalizedC)
    );
  });
}
